module.exports = __webpack_public_path__ + "static/media/keySVG.21421e17.svg";